import { Fragment, useState, useEffect, useCallback, useRef, useMemo, useLayoutEffect } from 'react';
import { Layout, Form, Row, Col, Input, Button, Space, Select, Table, TreeSelect, DatePicker, Tooltip, Flex, Card, theme } from 'antd';
import { filterFormItemLayout, filterFormGridLayout, filterFormItemStyle, computeButtonColLayout, fullPagerConfig } from '@utils/property';
import { useLocation, useNavigate } from 'react-router-dom';
import { get } from '@/core/request';
import dayjs from 'dayjs';
import PageHeader from '@components/PageHeader/PageHeader';
import { useHorizontalScrollGuard } from '@/hooks/useHorizontalScrollGuard';
import { useTableScrollY } from '@/hooks/useTableScrollY';
import { useVerticalScrollShadow } from '@/hooks/useVerticalScrollShadow';
import { useEnableTableScrollYLayout } from '@/layouts/tableScrollLayout';
import { useFilterPanelVisible } from '@/hooks/useFilterPanelVisible';
import './AuthUsers.less';

export default function BiChannelAuthUsers() {
    const { token } = theme.useToken();
    const { filterToggleProps, FilterPanelSlot } = useFilterPanelVisible();
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const { RangePicker } = DatePicker;
    const [form1] = Form.useForm();
    const navigate = useNavigate();
    const [limit, setLimit] = useState(20);
    const [page, setPage] = useState(1);
    let [num, setNum] = useState(0);
    const location = useLocation();
    const pathname = location.state;
    const [falg, setFalg] = useState(true);
    const [dataSource, setDataSource] = useState(null);
    const [formData, setFormData] = useState({ startTime: '', endTime: '', memCard: '', memNickname: '', memMobile: '', memUnit: '', memOffice: '', memPost: '', memJobtitle: '', contentId: '', contentType: '', contentTitle: '' });
    const [showElement, setShowElement] = useState(false);
    const [sourceType, setSourceType] = useState(null);
    const [treeData, setTreeData] = useState(null);
    const [memJobtitleData, setMemJobtitleData] = useState(null); //职称
    const [memPostData, setMemPostData] = useState(null); //职务

    const tableRegionRef = useRef(null);
    const tableScrollContainerRef = useRef(null);
    const [scrollContainerVersion, setScrollContainerVersion] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const enableTableScrollYLayout = useEnableTableScrollYLayout();
    const tableDeductSelectors = useMemo(() => ['.bi-channel-auth-users-table-toolbar'], []);
    const tableScrollY = useTableScrollY(tableRegionRef, {
        enabled: enableTableScrollYLayout || isFullscreen,
        heightRootClassName: 'main-container-card',
        scrollYOffset: 0,
        deductSiblingSelectors: tableDeductSelectors,
    });

    useHorizontalScrollGuard(tableScrollContainerRef, {
        threshold: 6,
        edgeHoldMs: 220,
        watchValue: scrollContainerVersion,
    });
    useVerticalScrollShadow(tableScrollContainerRef, {
        threshold: 2,
        watchValue: scrollContainerVersion,
    });

    useLayoutEffect(() => {
        const region = tableRegionRef.current;
        if (!region) return;

        const resolveScrollContainer = () => {
            const next = region.querySelector('.ant-table-body') ?? region.querySelector('.ant-table-content');
            if (tableScrollContainerRef.current !== next) {
                tableScrollContainerRef.current = next;
                setScrollContainerVersion(v => v + 1);
            }
        };

        resolveScrollContainer();

        let rafId = 0;
        const mutationObserver = new MutationObserver(() => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                resolveScrollContainer();
            });
        });
        mutationObserver.observe(region, { childList: true, subtree: true });

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
        };
    }, []);

    const handleToggleFullscreen = useCallback(() => {
        const target = document.querySelector('main.main-container');
        if (!target) return;
        const next = !target.classList.contains('is-page-fullscreen');
        target.classList.toggle('is-page-fullscreen', next);
        setIsFullscreen(next);
    }, []);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.key !== 'Escape') return;
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (!target) return;
            target.classList.remove('is-page-fullscreen');
            setIsFullscreen(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    useEffect(() => {
        return () => {
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (target) target.classList.remove('is-page-fullscreen');
        };
    }, []);

    const onChangeSelect = value => {
        if (value) {
            setShowElement(true);
        } else {
            setShowElement(false);
        }
    };
    useEffect(() => {
        get(`/channel/dictionary/office/detail`).then(
            res => {
                const result = deepCloneDisabled(res.data);
                setTreeData(result);
            },
            err => {
                console.log(err);
            },
        );
        get(`/channel/dictionary/source/type`).then(
            res => {
                if (res.status_code == 200) {
                    const arr = [];
                    for (var a in res.data) {
                        arr.push(res.data[a]);
                    }
                    setSourceType(arr);
                }
            },
            err => {
                console.log(err);
            },
        );
    }, []);
    const onReset = () => {
        setFalg(false);
        setFormData({ ...formData, memCard: '', memNickname: '', memMobile: '', memUnit: '', memOffice: '', memPost: '', memJobtitle: '', contentId: '', contentType: '', contentTitle: '' });

        setPage(1);
        form1.resetFields();
        form1.setFieldsValue({ time: '' });
        setNum(++num);
    };
    const columns = [
        { title: '用户唯一标识', dataIndex: 'memCard' },
        {
            title: '用户昵称',
            dataIndex: 'memNickname',
        },
        {
            title: '手机号',
            dataIndex: 'memMobile',
        },
        {
            title: '用户身份',
            dataIndex: 'memIdentityName',
        },
        {
            title: '会员类别',
            dataIndex: 'vipLevel',
        },
        {
            title: '单位名称',
            dataIndex: 'memUnit',
        },
        {
            title: '科室',
            dataIndex: 'memOfficeName',
        },
        {
            title: '职务',
            dataIndex: 'memPostName',
        },
        {
            title: '职称',
            dataIndex: 'memJobtitleName',
        },
        {
            title: '认证提审时间',
            dataIndex: 'authTime',
        },
        {
            title: '认证审核时间',
            dataIndex: 'examineTime',
        },
        {
            title: '转化来源类型',
            dataIndex: 'contentType',
        },
        {
            title: (
                <div>
                    实体ID&nbsp;
                    <Tooltip placement="top" title={'对应所选转化来源类型的实体ID，如选PGC文章时，即PGC文章ID'}>
                        <i className="bi bi-info-circle"></i>
                    </Tooltip>
                </div>
            ),
            dataIndex: 'contentId',
        },
        {
            title: '实体标题',
            dataIndex: 'contentTitle',
        },
        {
            title: '来源URL',
            dataIndex: 'url',
        },
    ];
    const onChangeTreeSelect = value => {
        console.log(value);
    };
    const clickBackHandler = () => {
        navigate('/operation/bi/channel/users');
    };
    const onFinish = values => {
        setFormData({
            ...formData,
            memCard: values.memCard || '',
            memNickname: values.memNickname || '',
            memMobile: values.memMobile || '',
            memUnit: values.memUnit || '',
            memOffice: values.memOffice || '',
            memPost: values.memPost || '',
            memJobtitle: values.memJobtitle || '',
            contentType: values.contentType || '',
            contentTitle: values.contentTitle || '',
            contentId: values.contentId || '',
        });

        setNum(++num);
    };
    function deepCloneDisabled(result) {
        for (let i = 0; i < result.length; i++) {
            result[i].title = result[i].dicName;
            result[i].value = result[i].dicCode;
            result[i].disabled = true;
            if (result[i].children.length) {
                result[i].children.forEach(item => {
                    item.title = item.dicName;
                    item.value = item.dicCode;
                });
            }
        }
        return result;
    }
    const handleChangeTime = (value, dateString) => {
        setFalg(false);
        setFormData({ ...formData, startTime: dateString[0], endTime: dateString[1] });
    };
    useEffect(() => {
        if (pathname && pathname.showTime) {
            onReset();
        }
    }, []);
    useEffect(() => {
        if (pathname) {
            const { startTime, endTime, memCard, memNickname, memMobile, memUnit, memOffice, memPost, memJobtitle, contentType, contentTitle, contentId } = formData;
            get(`/channel/statistics/authUser`, {
                channelId: pathname.channelId,
                startTime: falg ? pathname.startTime : startTime,
                endTime: falg ? pathname.endTime : endTime,
                page,
                limit,
                memCard,
                memNickname,
                memMobile,
                memUnit,
                memOffice,
                memPost,
                memJobtitle,
                contentType,
                contentTitle,
                contentId,
            }).then(
                res => {
                    if (res.status_code == 200) {
                        setDataSource(res.data);
                    }
                },
                err => {
                    console.log(err);
                },
            );
        }
    }, [limit, page, num]);
    useEffect(() => {
        get(`/channel/dictionary/board?type=3`).then(res => {
            setMemPostData(res.data);
        });
        get(`/channel/dictionary/board?type=4`).then(res => {
            setMemJobtitleData(res.data);
        });
    }, []);
    const changeCurrPage = useCallback(page => {
        setPage(page);
    }, []);
    const changePageSize = useCallback(pageSize => {
        setLimit(pageSize);
    }, []);
    const paginationProps = {
        ...fullPagerConfig,
        showSizeChanger: { placement: 'topRight' },
        current: page,
        showTotal: () => `共${dataSource.totalCount}条记录`,
        pageSize: limit,
        size: 'small',
        total: dataSource && dataSource.totalCount,
        onShowSizeChange: (current, pageSize) => changePageSize(pageSize),
        onChange: page => {
            changeCurrPage(page);
        },
    };

    const onRefresh = () => {
        setNum(n => n + 1);
    };

    const channelName = pathname?.name ?? '';

    return (
        <div className="page-container bi-channel-auth-users-page">
            <PageHeader title={`渠道认证用户 ${channelName ? `[${channelName}]` : ''}`} breadcrumb={[{ label: '运营中心', path: '/operation/channels' }, { label: '渠道用户数据', path: '/operation/bi/channel/users' }, { label: '渠道认证用户' }]} {...filterToggleProps} />

            <FilterPanelSlot>
                <Card
                    size="small"
                    className="bi-channel-auth-users-filter"
                    style={{
                        marginBottom: token.marginLG,
                        border: `1px solid ${token.colorBorderSecondary}`,
                        background: token.colorFillAlter,
                    }}
                >
                    <Form {...filterFormItemLayout} onFinish={onFinish} form={form1} autoComplete="off" requiredMark={false}>
                        <Row gutter={[16, 16]}>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="用户唯一标识" name="memCard" style={filterFormItemStyle}>
                                    <Input allowClear placeholder="用户唯一标识" />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="用户昵称" name="memNickname" style={filterFormItemStyle}>
                                    <Input allowClear placeholder="用户昵称" />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="手机号" name="memMobile" style={filterFormItemStyle}>
                                    <Input allowClear placeholder="手机号" />
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="认证审核时间" name="time" style={filterFormItemStyle}>
                                    {pathname && <RangePicker defaultValue={[dayjs(pathname.startTime, dateFormat), dayjs(pathname.endTime, dateFormat)]} format={dateFormat} showTime onChange={handleChangeTime} style={{ width: '100%' }} />}
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="单位名称" name="memUnit" style={filterFormItemStyle}>
                                    <Input allowClear placeholder="单位名称关键字" />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="科室" name="memOffice" style={filterFormItemStyle}>
                                    {treeData && <TreeSelect style={{ width: '100%' }} styles={{ popup: { root: { maxHeight: 400, overflow: 'auto' } } }} treeData={treeData} placeholder="选择渠道分类" onChange={onChangeTreeSelect} />}
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="职务" name="memPost" style={filterFormItemStyle}>
                                    <Select allowClear placeholder="选择职务">
                                        {memPostData
                                            && memPostData.map(item => {
                                                return <Select.Option value={item.dicCode}>{item.dicName}</Select.Option>;
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="职称" name="memJobtitle" style={filterFormItemStyle}>
                                    <Select allowClear placeholder="选择职称">
                                        {memJobtitleData
                                            && memJobtitleData.map(item => {
                                                return <Select.Option value={item.dicCode}>{item.dicName}</Select.Option>;
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="转化来源类型" name="contentType" style={filterFormItemStyle}>
                                    <Select allowClear placeholder="转化来源类型" onChange={onChangeSelect}>
                                        {sourceType
                                            && sourceType.map((item, i) => {
                                                return <Select.Option value={i + 1}>{item}</Select.Option>;
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            {showElement && (
                                <Col {...filterFormGridLayout}>
                                    <Form.Item label="实体ID" name="contentId" style={filterFormItemStyle} tooltip={{ title: '对应所选转化来源类型的实体ID，如选PGC文章时，即PGC文章ID', icon: <i className="bi bi-info-circle"></i> }}>
                                        <Input allowClear placeholder="转化来源实体ID" />
                                    </Form.Item>
                                </Col>
                            )}
                            {showElement && (
                                <Col {...filterFormGridLayout}>
                                    <Form.Item label="实体标题" name="contentTitle" style={filterFormItemStyle}>
                                        <Input allowClear placeholder="实体标题关键字" />
                                    </Form.Item>
                                </Col>
                            )}
                            <Col {...computeButtonColLayout(showElement ? 11 : 9)}>
                                <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                                    <Space size="small">
                                        <Button type="default" onClick={onReset}>
                                            重置
                                        </Button>
                                        <Button type="primary" icon={<i className="bi bi-search" aria-hidden="true" />} htmlType="submit">
                                            检索
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </FilterPanelSlot>

            <div ref={tableRegionRef} className="bi-channel-auth-users-table-region">
                <div className="main-toolbar bi-channel-auth-users-table-toolbar">
                    <div className="main-tools">
                        <span className="table-title">渠道认证用户列表</span>
                    </div>
                    <div className="sub-tools">
                        <Space>
                            <Tooltip title="刷新列表">
                                <Button type="default" onClick={onRefresh} icon={<span className="bi bi-arrow-clockwise" aria-hidden="true" />} aria-label="刷新列表" />
                            </Tooltip>
                            <Tooltip title={isFullscreen ? '退出全屏' : '全屏'}>
                                <Button type="default" onClick={handleToggleFullscreen} icon={<span className={isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'} aria-hidden="true" />} aria-label={isFullscreen ? '退出全屏' : '全屏'} />
                            </Tooltip>
                        </Space>
                    </div>
                </div>

                <div className="bi-channel-auth-users-table-wrap">
                    <Table
                        className={tableScrollY != null ? 'custom-table-scrollbar-always' : undefined}
                        rowKey="id"
                        columns={columns}
                        dataSource={dataSource?.list}
                        scroll={{
                            x: 'max-content',
                            ...(tableScrollY != null ? { y: tableScrollY } : {}),
                        }}
                        sticky
                        pagination={paginationProps}
                    />
                </div>
            </div>
        </div>
    );
}
